<template>
  <LayoutsGlobal>
    <slot />
  </LayoutsGlobal>
</template>

<script setup lang="ts">
import { COMMON_TITLE } from '@/wabunka-src/constants/metaTag';

const runtimeConfig = useRuntimeConfig();

const TITLE = COMMON_TITLE;
const DESCRIPTION = 'Pull back the curtain on the real Japan with exclusive private tours and expert-led experiences.';

const meta = [
  {
    name: 'description',
    content: DESCRIPTION,
  },
  {
    property: 'og:title',
    content: TITLE,
  },
  {
    property: 'og:description',
    content: DESCRIPTION,
  },
  {
    property: 'og:image',
    content: `${runtimeConfig.public.BASE_URL}/en_ogp.png`,
  },
];

/**
 * クライアント側で実行されると個別ページで設定したメタ情報を書き換えてしまうのでサーバー側での実行のみとする
 */
useServerHead({ title: TITLE, meta });
</script>
